import React, {Component} from "react";
import Loading from "./Loading";

class IFrame extends Component {
	state = {
		isLoad : false
	};

	onLoad() {
		this.setState({isLoad : true});
	}

	render() {
		const iframe = document.getElementById('tracker_frame');

		return (
			<div className="iframe">
				{!this.state.isLoad && <div className="iframe__loading"><Loading/></div>}
				<iframe id="tracker_frame"
				        src={this.props.src}
				        frameBorder="0"
				        allowTransparency="true"
				        allowFullScreen="true"
				        allowScriptAccess="always"
				        onLoad={this.onLoad.bind(this)}></iframe>
			</div>
		);
	}
}

export default IFrame;


// WEBPACK FOOTER //
// ./src/app/components/IFrame.js